var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1018)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60938 0.15625L4.09375 0.672852L0.789062 3.83984L0.25 4.33398L5.64062 9.5L1.89062 13.0938L1.84375 13.3184L1.02344 17.2715L0.789062 18.3271L1.89062 18.1025L6.01562 17.3164L6.25 17.2715L10 13.6777L15.3672 18.8213L15.8828 18.3047L19.1875 15.1377L19.7266 14.6436L14.3594 9.5L18.0625 5.95117C19.2695 4.79443 19.2695 2.93018 18.0625 1.77344C17.459 1.19507 16.6709 0.897461 15.8828 0.897461C15.0947 0.897461 14.3066 1.19507 13.7031 1.77344L10 5.32227L4.60938 0.15625ZM4.60938 2.2002L6.0625 3.61523L4.96094 4.6709L6.03906 5.7041L7.14062 4.64844L8.92188 6.35547L6.69531 8.48926L2.35938 4.33398L4.60938 2.2002ZM15.8828 2.29004C16.2725 2.29004 16.668 2.4585 17.0078 2.78418C17.6846 3.43274 17.6846 4.26941 17.0078 4.91797L16.5156 5.38965L14.2891 3.25586L14.7812 2.78418C15.1211 2.4585 15.4932 2.29004 15.8828 2.29004ZM13.2344 4.2666L15.4609 6.40039L6.39062 15.0928C5.89551 14.1803 5.11621 13.4335 4.16406 12.959L13.2344 4.2666ZM13.3047 10.5107L15.0859 12.2178L13.9609 13.2959L15.0391 14.3291L16.1641 13.251L17.5938 14.6211L15.3438 16.7773L11.0547 12.667L13.3047 10.5107ZM3.20312 14.1045C4.10254 14.4667 4.81738 15.1517 5.19531 16.0137L2.71094 16.4854L3.20312 14.1045Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.1fdbe062.svg";
export { ForwardRef as ReactComponent };